import { useTranslation } from 'react-i18next';
import { Stack } from '@koob/margaret';
import { Form, Formik } from 'formik';
import { KoobButton, KoobInputTextareaField } from '@koob/ui';

const DenyExplainationForm = ({ onSubmit, initialValues }) => {
  const { t } = useTranslation('settingRequest');

  return (
    <Formik
      initialValues={
        initialValues ?? {
          reason: '',
        }
      }
      onSubmit={onSubmit}
    >
      {() => (
        <Form>
          <Stack direction="column" gutterSize={1}>
            <KoobInputTextareaField label={t('reason')} name="reason" />
          </Stack>

          <Stack marginTop={2} size="full" alignX="flex-end">
            <KoobButton
              type="submit"
              variant="primary"
              style={{ minWidth: 120, minHeight: 40, marginLeft: 25 }}
            >
              {t('misc:save')}
            </KoobButton>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default DenyExplainationForm;
